import { Activity, GraphGroup, TAGS } from "components/planner/types"
import { groupBy, roundValue } from "components/planner/utils"
import { Cycle } from "types/Cycle"
import { dateWithoutTime } from "utils/time"



/**
 * Inserendo i CYCLE restituisco il GRAPH-GROUP delle somme di tutti i yield
 */
export function buildYeldGroup(cycles?: Cycle[], isLab?: boolean): GraphGroup {

	// ottengo le ACTIVITIES per "plannedYield"
	const cyclesPlanned = cycles.filter(cycle => cycle.plannedYield)
	const activitiesPlannedYield = getActionFromCycles(
		cyclesPlanned,
		cycle => cycle.plannedYield,
		0
	)

	// se il CYCLE ha la yieldDate ma non ha il valore di yield, lo calcolo come somma di ogni CROP-LOT (se esistono)	
	const cyclesActual = cycles.filter(cycle => cycle.yieldDate)
	for (const cycle of cyclesActual) {
		if (!(cycle.cropLots?.length > 0)) continue
		if (cycle.yield == null) cycle.yield = cycle.cropLots.reduce((acc, cl) => acc + cl.yield, 0)
		if (cycle.unitsYield == null) cycle.unitsYield = cycle.cropLots.reduce((acc, cl) => acc + cl.unitsYield, 0)
	}

	// ottengo le ACTIVITIES per "yield"
	const activitiesYield = getActionFromCycles(
		cyclesActual,
		cycle => cycle.yield,
		1
	)
	const activitiesPlannedUnitsYield = getActionFromCycles(
		cyclesActual,
		cycle => cycle.plannedUnitsYield,
		2
	)
	const activitiesUnitsYield = getActionFromCycles(
		cyclesActual,
		cycle => cycle.unitsYield,
		3
	)

	// creo il GROUP
	const yieldGroup: GraphGroup = {
		name: "yield",
		title: "YIELD",
		collapsed: false,
		labels: isLab ? ["EXPECTED [kg]"] : ["EXPECTED [kg]", "ACTUAL [kg]", "EXPECTED [units]", "ACTUAL [units]"],
		activities: [...activitiesPlannedYield, ...activitiesYield, ...activitiesPlannedUnitsYield, ...activitiesUnitsYield ],
		unselectable: true,
		noCompact: true,
		activitiesHistogram: activitiesPlannedYield,
	}
	return yieldGroup
}





/** 
 * array di dati yield "effective" 
 * @param cycles i CYCLES da analizzare
 * @param fnGetValue la funzione che estrapola il valore da sommare (tipicamente: plannedYield e yield)
 * @param row la row da assegnare a queste ACTIVITY
 * */
function getActionFromCycles(
	cycles: Cycle[],
	fnGetValue: (cycle: Cycle) => number,
	row: number = 0,
): Activity[] {

	// Raggruppo i CYCLES in base alla data di raccolta "harvestingDate"
	const cyclesGroups = groupBy<Cycle>(
		cycles,
		(c1, c2) => c1.harvestingDate == c2.harvestingDate
	)

	// la ACTIVITY dello stesso giorno con la somma dei valori e i riferimenti in TAGS
	const activities = cyclesGroups.reduce((acc, cyclesGroup) => {
		// la somma dei valori
		const sum = cyclesGroup.reduce((sum, cycle) => sum + (fnGetValue(cycle) ?? 0), 0)
		if (isNaN(sum) || sum == 0) return acc
		const dateString = cyclesGroup[0].harvestingDate

		// creo l'ACTIVITY
		const activity = {
			tags: { [TAGS.CYCLES]: cyclesGroup.map(c => c.cycleUuid) },
			start: dateWithoutTime(dateString),
			row,
			label: roundValue(sum),
			value: sum,
		} as Activity
		return [...acc, activity]
	}, [] as Activity[])

	return activities
}


